import styled from "styled-components";

export const PlayerVideoSC = styled.div`
  z-index: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
`;
